import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import { serverBaseURL } from "common/settings";
import { caculateLifetime } from "common/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

function Lifetime() {
  const { getToken } = useKindeAuth();

  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(0);

  const [lifetimeData, setLifetimeData] = useState({});
  const [fpLifetimeData, setFpLifetimeData] = useState({});

  async function fetchSites() {
    const accessToken = await getToken();
    const response = await (
      await fetch(`${serverBaseURL}sites`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
    ).json();
    setSites(response);
  }

  useEffect(() => {
    fetchSites();
  }, []);

  function selectChange(event) {
    setSelectedSite(event.target.value);
    fetchSiteData(event.target.value);
  }

  async function fetchSiteData(siteId) {
    const accessToken = await getToken();
    const response = await (
      await fetch(`${serverBaseURL}get_trend_result?system_type=ongrid`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
    ).json();
    const displaySite = response.sites.filter((site) => site.site == siteId)[0];
    caculateLifetime(displaySite);

    const yearlabels = [];
    for (let i = 0; i <= displaySite.years; i += 1) {
      yearlabels.push(displaySite.installed_year + i);
    }

    setLifetimeData({
      labels: yearlabels,
      datasets: [
        {
          label: "degradation",
          color: "dark",
          data: displaySite.lifetime_series,
        },
      ],
    });

    const fpYearlabels = [];
    for (let i = 0; i <= displaySite.fp_years; i += 1) {
      fpYearlabels.push(displaySite.installed_year + i);
    }

    setFpLifetimeData({
      labels: fpYearlabels,
      datasets: [
        {
          label: "degradation",
          color: "dark",
          data: displaySite.fp_lifetime_series,
        },
      ],
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <MDBox p={5}>
          <FormControl fullWidth>
            <InputLabel id="sites-label">Sites</InputLabel>
            <Select
              labelId="sites-label"
              id="sites-select"
              value={selectedSite}
              label="Select Site"
              sx={{ minHeight: "50px", maxWidth: "200px" }}
              onChange={selectChange}
            >
              {sites.map((site, index) => (
                <MenuItem key={index} value={site.id}>
                  {site.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </MDBox>
      </MDBox>
      <MDBox pb={3}>
        <MDBox mt={8}>
          <MDTypography mt={2} variant="h3" align="center" sx={{ color: "#484731" }}>
            Lifetime
          </MDTypography>
        </MDBox>
        <MDBox mt={4} display="flex" justifyContent="center" alignItems="center">
          <MDBox width="60rem">
            <GradientLineChart title="" chart={lifetimeData} />
          </MDBox>
        </MDBox>
      </MDBox>
      <MDBox pb={3}>
        <MDBox mt={8}>
          <MDTypography mt={2} variant="h3" align="center" sx={{ color: "#484731" }}>
            FP Lifetime
          </MDTypography>
        </MDBox>
        <MDBox mt={4} display="flex" justifyContent="center" alignItems="center">
          <MDBox width="60rem">
            <GradientLineChart title="" chart={fpLifetimeData} />
          </MDBox>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default Lifetime;
